/**
 * Static, local page content for the Press page. Contentful is intentionally out of scope for v1;
 * all copy/data lives here so the page stays self-contained and reviewable.
 */

import teamNeonImage from './assets/illustrations/ulule-team-neon.jpg?url'
import pitchImage from './assets/illustrations/ulule-pitch-on-stage.jpg?url'
import qaImage from './assets/illustrations/ulule-q-a.jpg?url'
import talkImage from './assets/illustrations/ulule-talk.jpeg?url'
import eventImage from './assets/illustrations/ulule-event.jpg?url'
import teamWorkingImage from './assets/illustrations/ulule-team-working.jpg?url'

import leMondeLogo from './assets/logos/media/le-monde.svg?url'
import wiredLogo from './assets/logos/media/wired.svg?url'
import franceinfoLogo from './assets/logos/media/franceinfo.svg?url'
import nytLogo from './assets/logos/media/the-new-york-times.svg?url'
import lesEchosLogo from './assets/logos/media/les-echos.svg?url'
import liberationLogo from './assets/logos/media/liberation.svg?url'
import teleramaLogo from './assets/logos/media/telerama.svg?url'
import tf1Logo from './assets/logos/media/tf1.svg?url'
import france3Logo from './assets/logos/media/france-3.svg?url'
import radioNovaLogo from './assets/logos/media/radio-nova.svg?url'
import franceInterLogo from './assets/logos/media/france-inter.svg?url'
import ouestFranceLogo from './assets/logos/media/ouest-france.svg?url'
import leFigaroLogo from './assets/logos/media/le-figaro.svg?url'
import theGuardianLogo from './assets/logos/media/the-guardian.svg?url'

// `scale` is an optional optical-balance multiplier on the shared logo size cap (default 1).
// Marks whose intrinsic proportions render visually small in the cells (a square tile, or a
// wordmark with slack) get a nudge so the row reads evenly; it's clamped to the card in CSS.
export type MediaOutlet = { name: string; logo: string; scale?: number }

/** Media outlets that regularly cover Ulule. `name` doubles as the logo's alt text. */
export const MEDIA_OUTLETS: MediaOutlet[] = [
  { name: 'Le Monde', logo: leMondeLogo },
  { name: 'Wired', logo: wiredLogo },
  { name: 'franceinfo', logo: franceinfoLogo },
  { name: 'The New York Times', logo: nytLogo, scale: 1.28 },
  { name: 'Les Échos', logo: lesEchosLogo },
  { name: 'Libération', logo: liberationLogo },
  { name: 'Télérama', logo: teleramaLogo },
  { name: 'TF1', logo: tf1Logo },
  { name: 'France 3', logo: france3Logo },
  { name: 'Radio Nova', logo: radioNovaLogo },
  { name: 'France Inter', logo: franceInterLogo, scale: 1.38 },
  { name: 'Ouest-France', logo: ouestFranceLogo },
  { name: 'Le Figaro', logo: leFigaroLogo },
  { name: 'The Guardian', logo: theGuardianLogo },
]

export type Illustration = { caption: string; image: string }

// Event/community photos leading, then two shots kept from the original set.
export const ILLUSTRATIONS: Illustration[] = [
  { image: teamNeonImage, caption: 'Soirée de la communauté Ulule' },
  { image: pitchImage, caption: 'Un créateur présente son projet' },
  { image: qaImage, caption: 'Échanges avec la communauté' },
  { image: talkImage, caption: "Prise de parole lors d'un événement" },
  { image: eventImage, caption: "Dans les coulisses d'Ulule" },
  { image: teamWorkingImage, caption: "L'équipe au travail" },
]
